// extracted by mini-css-extract-plugin
export var equalColumn = "_hz-0";